import OrderItem from './order-item';
import { popupOpen, popupClose, popupInit } from '../utils';

export default class Cart {
    constructor(selector = '#cart') {
        const orderAddForm = document.querySelector('[data-ui-el="order-add-form"]') || null;

        this.initialized = false;
        this.isUpdate = false;
        this.selector = selector;

        this.init();

        if (orderAddForm) {
            this.orderAddForm = orderAddForm;
            this.orderItem = new OrderItem(orderAddForm);
            this.isProductPage = true;
            this.addCartRoute = orderAddForm.dataset.addRoute;
            this.btnContainer = orderAddForm.querySelector('[data-ui-el="btn-container"]');
            this.addCartButton = this.btnContainer.querySelector('[data-ui-el="add-cart-btn"]');
            this.inCartButton = this.btnContainer.querySelector('a[href="#cart"]');

            if (this.orderItem.sizeList) {
                [...this.orderItem.sizeList].forEach((input) => {
                    this.orderItem.changeSizeEvent(input, (inCart) => {
                        this.changeOrderButton(inCart);
                    });
                });
            }

            if (!this.addCartButton || !this.inCartButton) {
                return;
            }

            popupInit(this.inCartButton);

            this.addOrderEvent();
            this.changeOrderButton(this.orderItem?.currentSize?.inCart);
            this.btnContainer.removeAttribute('hidden');
        }
    }

    /**
     * @param {String} route
     * @param {Object} options
     * @return {Promise}
     */
    static fetch(route, options) {
        return fetch(route, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            ...options,
        });
    }

    /**
     *@param {Boolean} inCart
     */
    changeOrderButton(inCart) {
        if (!this.inCartButton || !this.addCartButton) {
            return;
        }

        this.btnContainer.classList.remove('in-cart');

        if (inCart) {
            this.btnContainer.classList.add('in-cart');
        }
    }

    show() {
        popupOpen(this.domElement);
    }

    /**
     * @param {String} cartTemplate
     * @param {Number} cartQuantity
     */
    create(cartTemplate, cartQuantity) {
        if (!cartTemplate) {
            return;
        }

        document.querySelector('body .wrapper').insertAdjacentHTML('afterend', cartTemplate);
        this.changeHeaderCartCount(cartQuantity);
        this.init();
    }

    destroy() {
        this.changeOrderButton();
        popupClose();
        this.domElement.remove();
        this.changeHeaderCartCount();

        this.initialized = false;
    }

    /**
     * @param {String} cartTemplate
     * @param {Number} cartQuantity
     */
    refresh(cartTemplate, cartQuantity) {
        if (!cartTemplate) {
            this.destroy();
            return;
        }

        const newCart = document.createElement('div');

        newCart.innerHTML = cartTemplate;
        this.domElement.innerHTML = newCart.querySelector(this.selector).innerHTML;

        this.changeHeaderCartCount(cartQuantity);
        this.init();
    }

    /**
     * @param {String} route
     * @param {Object} options
     * @return {Promise}
     */
    async render(route, options) {
        const preloader = document.querySelector('[data-ui-el="popup-preloader"]');

        preloader.classList.add('active');
        const response = await Cart.fetch(route, options);
        preloader.classList.remove('active');

        if (response.status === 500) {
            this.clearCartError500();

            const errorTemplate = document.querySelector('#error-500-temp');
            const errorContent = errorTemplate.content.cloneNode(true);
            const cartTotalError = `
                                          <p class="cart-error-message cart-error-message_total" data-error-cart="500">
                                              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M8.37109 0C3.95509 0 0.371094 3.584 0.371094 8C0.371094 12.416 3.95509 16 8.37109 16C12.7871 16 16.3711 12.416 16.3711 8C16.3711 3.584 12.7871 0 8.37109 0ZM9.17109 12H7.57109V10.4H9.17109V12ZM9.17109 8.8H7.57109V4H9.17109V8.8Z" fill="#E80000"/>
                                              </svg>
                                              <span data-error="total">${errorContent.firstElementChild.textContent}</span>
                                          </p>
                                          `;

            if (this.domElement && this.domElement.classList.contains('open')) {
                document.querySelector('[data-ref="action"]').insertAdjacentHTML('beforebegin', cartTotalError);
                return;
            }

            if (this.addCartButton) {
                this.addCartButton.insertAdjacentHTML('afterend', cartTotalError);
                return;
            }
        }

        if (response.ok) {
            const result = await response.json();

            if (result.status && result.url) {
                window.location.href = result.url;

                return;
            }

            this.isUpdate = true;

            if (!this.initialized) {
                this.create(result.view, result.cartQuantity);

                return result;
            }

            this.refresh(result.view, result.cartQuantity);

            return result;
        } else {
            return response.json();
        }
    }

    addOrderEvent() {
        this.orderAddForm.addEventListener('submit', (event) => {
            event.preventDefault();

            this.render(this.addCartRoute, {
                body: new FormData(this.orderAddForm),
            }).then((result) => {
                if (!result) {
                    return;
                }

                if (result.cartQuantity) {
                    this.orderItem.currentSize.element.setAttribute('data-in-cart', 1);
                    this.orderItem.currentSize.inCart = true;
                    this.changeOrderButton(true);
                    this.show();
                }

                if (!result.status) {
                    for (const resultKey in result['messages']) {
                        const element = document.querySelector(`[data-error-id="${resultKey}"]`);
                        element.innerHTML = result['messages'][resultKey][0];
                        element.style.display = 'inline-block';
                    }
                }
            });
        });
    }

    /**
     * @param {String} id
     */
    deleteOrder(id) {
        const formData = new FormData();

        formData.append('id', id);
        this.render(this.deleteRoute, {
            body: formData,
        });
    }

    /**
     * @param {Event} event
     */
    deleteItem = (event) => {
        const { target } = event;

        if (!target.closest('[data-cart="delete"]')) {
            return;
        }

        this.deleteOrder(target.closest('[data-cart="item"]').dataset.id);

        if (!this.isProductPage) {
            return;
        }

        const listItem = target.closest('[data-size-id]');
        const { sizeId } = listItem.dataset;

        let pageProductInput

        if (sizeId) {
            pageProductInput = document.querySelector(`input[name="size_id"]#${sizeId}`);
        }

        const productSizeId = listItem.querySelector('[name="size"]').value;

        if (pageProductInput && productSizeId === pageProductInput?.value) {
            if (document.querySelector(`#${sizeId}`)) {
                document.querySelector(`#${sizeId}`).dataset.inCart = '0';
            }

            if (pageProductInput?.checked) {
                this.changeOrderButton(false);
                this.orderItem.currentSize.inCart = false;
                this.orderItem.currentSize.element.dataset.inCart = '0';
            }
        }
    };

    /**
     * @param {String} id
     * @param {String} quantity
     * @param {String} currency
     */
    quantityUpdate(item) {
        const formData = new FormData();

        formData.append('id', item.productId);
        formData.append('quantity', item.productQuantity);
        formData.append('currency', item.currency);
        this.render(this.updateRoute, {
            body: formData,
        });
    }

    /**
     *@param {Number} quantity
     */
    changeHeaderCartCount(quantity = 0) {
        const headerCounts = document.querySelectorAll('[data-cart="count"]');

        if (headerCounts.length > 0) {
            [...headerCounts].forEach(item => {
                if (quantity === 0) {
                    item.parentElement.classList.add('disabled');
                    item.remove();
                } else {
                    item.innerHTML = quantity;
                }
            });

            return;
        }

        const headerCarts = document.querySelectorAll('[data-ui-el="header"] .cart-header[href="#cart"]');
        const headerCountTemp = `<span class="cart-header__count" data-cart="count">${quantity}</span>`;

        [...headerCarts].forEach(headerCart => {
            headerCart.classList.remove('disabled');
            headerCart.insertAdjacentHTML('beforeend', headerCountTemp);
        });
    }

    /**
     *@param {Boolean} isDisable
     */
    disableCartButton(isDisable) {
        if (isDisable) {
            this.confirmButton.setAttribute('disabled', '');
            return;
        }

        this.confirmButton.removeAttribute('disabled');
    }

    /**
     * @param {String} selector
     */
    init(selector = this.selector) {
        const cart = document.querySelector(selector);

        if (!cart) {
            return false;
        }

        this.initialized = true;
        this.domElement = cart;
        this.cartForm = cart.querySelector('[data-ui-el="cart-form"]');

        if (!this.cartForm) {
            return false;
        }

        this.deleteRoute = this.cartForm.dataset.deleteRoute;
        this.updateRoute = this.cartForm.dataset.updateRoute;
        this.confirmUrl = this.cartForm.getAttribute('action');
        this.confirmButton = this.cartForm.querySelector('[data-ui-el="confirm-btn"]');
        this.actionButtons = this.cartForm.querySelectorAll('[data-action-btn]');

        let orderList = Array.from(this.domElement.querySelectorAll('[data-cart="item"]'));

        this.orderList = orderList.map((orderItem) => {
            const productPriceEl = orderItem.querySelector('[data-ui-el="product-price"]');

            if (!productPriceEl) {
                return;
            }

            return new OrderItem(orderItem, productPriceEl, false);
        });

        this.orderList.forEach((item) => {
            if (!item) {
                return;
            }

            item.changeQuantityEvent(() => {
                this.quantityUpdate(item);
            });
        });
        this.domElement.removeEventListener('click', this.deleteItem);
        this.domElement.addEventListener('click', this.deleteItem);

        this.actionButtons.forEach((btn) => {
            const route = this.cartForm.getAttribute(`data-${btn.dataset.actionBtn}`);

            if (!route) {
                return;
            }

            btn.addEventListener('click', () => {
                const formData = new FormData();

                this.render(route, {
                    body: formData,
                });
            });
        });

        this.cartForm.addEventListener('submit', (event) => {
            event.preventDefault();

            this.render(this.cartForm.action, {
                body: new FormData(this.cartForm),
            });
        });

        this.domElement.addEventListener('collapse', () => {
            if (!this.isUpdate) {
                return;
            }

            this.isUpdate = false;

            if (document.querySelector('[data-ui-el="checkout-form"]')) {
                this.render(this.cartForm.action, {
                    body: new FormData(this.cartForm),
                });
            }
        });
    }

    clearCartError500() {
        const error500 = document.querySelector('[data-error-cart="500"]');

        if (error500) {
            error500.remove();
        }
    }
}
